export type ApiErrorLike = {
  response?: {
    status?: number;
  };
  config?: {
    url?: string;
    baseURL?: string;
  };
};

export const getHttpStatus = (error: unknown): number | null => {
  const status = (error as ApiErrorLike | undefined)?.response?.status;
  return typeof status === 'number' ? status : null;
};

export const isApiRequest = (error: ApiErrorLike, apiBase: string): boolean => {
  const requestUrl = error.config?.url || '';
  const fullUrl = `${error.config?.baseURL || ''}${requestUrl}`;
  const normalizedApiBase = apiBase.trim().replace(/\/+$/, '');
  const normalizedApiPath = /^https?:\/\//i.test(normalizedApiBase)
    ? new URL(normalizedApiBase).pathname.replace(/\/+$/, '')
    : normalizedApiBase;

  return (
    fullUrl.startsWith(normalizedApiBase) ||
    fullUrl.startsWith(normalizedApiPath) ||
    requestUrl.includes('/api/')
  );
};

export const shouldRedirectToLoginOnApiError = (error: unknown, apiBase: string): boolean => {
  const apiError = error as ApiErrorLike;
  return getHttpStatus(error) === 401 && isApiRequest(apiError, apiBase);
};
